import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import SvgIcon from '../../../base/components/svg-icon/svg-icon'

export const CarouselArrow = (props) => {
  const { icon, className, smallArrow, fillColor, ...otherProps } = props
  const ARROW_SIZE = smallArrow ? '10px' : '24px'
  const classes = useStyles({ fillColor, ARROW_SIZE })
  const arrowClasses = classNames(className, classes.arrow)

  return (
    <div className={arrowClasses} {...otherProps}>
      <SvgIcon svg={icon} width={ARROW_SIZE} height={ARROW_SIZE} />
    </div>
  )
}

CarouselArrow.props = {
  icon: PropTypes.string.isRequired,
}

const useStyles = makeStyles(() => ({
  arrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: props => {
      return `calc(50% - ${props.ARROW_SIZE})`
    },
    zIndex: '1',

    '& svg, & .st0': {
      fill: props => {
        return props.fillColor || '#111111'
      },
    },

    '&.slick-disabled': {
      '& svg, & .st0': {
        fill: 'rgba(40, 40, 40, 0.2)',
      },
    },
  },
}))

export default CarouselArrow
